module.exports = __webpack_public_path__ + "web.config";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[path][name].[ext]&context=./!./web.config
// module id = 216
// module chunks = 0